import Repository from "../Repository";

const resource = "/admanager";
export default {

    getOneOrder(orderId) {
        return Repository.get(`${resource}/orders/${orderId}`);
    },

}